module.exports = __webpack_public_path__ + "static/media/copyrights_icon.7ee5ab73.svg";